import type { QueryClient, QueryKey } from '@tanstack/react-query'

// After deep pagination React Query may retain only later pages. A normal
// refetch starts at that retained page, so it cannot retrieve the new broadcast.
export function refreshRadioStreamQuery(
    client: QueryClient,
    queryKey: QueryKey,
    refetch: () => unknown,
) {
    const data = client.getQueryData<{ pageParams?: unknown[] }>(queryKey)
    if (Number(data?.pageParams?.[0]) > 1) {
        return client.resetQueries({ queryKey, exact: true })
    }
    return refetch()
}
